import HeaderLayout from '../../../layouts/HeaderAsideLayout/HeaderLayout';
import MaterialEdit from "../../../pages/material/add";
import MaterialDetail from "../../../pages/material/detail";

const list = [
    {
        path: '/',
        component: HeaderLayout,
        children: [
            {
                path: '/material/add',
                component: MaterialEdit,
                name: 'addMaterial'
            },
            {
                path: '/material/detail',
                component: MaterialDetail,
                name: 'materialDetail'
            }
        ],
    }
]
export default list